// Real Web Push subscription (works even when tab is closed)
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function subscribeToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    toast.error("Tu navegador no soporta notificaciones push");
    return false;
  }
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") { toast.error("Permiso denegado"); return false; }
    const reg = await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
      });
    }
    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
    toast.success("Notificaciones activadas. Te avisaremos hasta cuando la web esté cerrada.");
    return true;
  } catch (e) {
    toast.error(apiErr(e) || "No se pudo activar notificaciones");
    return false;
  }
}

export async function unsubscribeFromPush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
    await api.delete("/push/subscribe");
    toast.success("Notificaciones desactivadas");
    return true;
  } catch { return false; }
}
